import { useQuery } from '@apollo/client';
import { LINE_MANAGERS_CATEGORY } from 'Home/Managers/constants';
import React from 'react';
import SectionError from 'Shared/SectionError';
import LoadingIndicator from 'Shared/LoadingIndicator';
import useIsManagerExperienceActive from 'Home/Managers/useIsManagerExperienceActive';
import Route404 from 'App/Router/Route404';
import useFeatureFlag, { FEATURE_FLAGS } from 'flags/useFeatureFlag';
import { MANAGER_CONTENT_QUERY } from './graphql/manager-content';
import {
  managerContent,
  managerContentVariables,
} from './graphql/__generated__/managerContent';
import * as S from './styles';
import { ManagersCategorySection } from './components';

const ManagersPage = () => {
  const { isManagerExperienceActive, loading: isManagerExperienceLoading } =
    useIsManagerExperienceActive();
  const isNovaPhase2Enabled = useFeatureFlag(FEATURE_FLAGS.NOVA_HOME_PHASE_2);

  const hasAccessToManagersPage =
    isNovaPhase2Enabled && isManagerExperienceActive;

  const { data, loading, error, refetch } = useQuery<
    managerContent,
    managerContentVariables
  >(MANAGER_CONTENT_QUERY, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
    returnPartialData: true,
    variables: { slug: LINE_MANAGERS_CATEGORY },
    skip: !hasAccessToManagersPage,
  });

  if (loading || isManagerExperienceLoading) {
    return <LoadingIndicator />;
  }

  if (!hasAccessToManagersPage) {
    return <Route404 />;
  }

  if (error) {
    return (
      <S.ErrorWrapper>
        <SectionError
          onRetry={async () => refetch({ slug: LINE_MANAGERS_CATEGORY })}
        />
      </S.ErrorWrapper>
    );
  }

  return (
    <S.ManagersWrapper>
      <S.ManagersScreenContainer>
        {data?.exploreCategory?.subCategories?.map(category =>
          category ? (
            <ManagersCategorySection
              key={category.slug}
              category={category}
              assetToken={data.getAssetToken?.assetToken ?? null}
            />
          ) : null,
        )}
      </S.ManagersScreenContainer>
    </S.ManagersWrapper>
  );
};

export default ManagersPage;
